import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { checkTokenValidation } from "../auth/tokenReq";

type createPaymentsReqPropType = {
  amount: number;
  receivedDate: string;
  txnDetails: string;
};

export const updateCompanyStatusReq = async (
  params: { companyID: any },
  props: { Status: string }
) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->createCEPAdminReq " + t
    );
  try {
    await checkTokenValidation();
    const body = props;

    const res = await authAxios.post(
      `${ApiKey.updateCompanyStatus}/${params?.companyID}/status`,
      body
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = {};
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const createPaymentsReq = async (data: createPaymentsReqPropType) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": cepAdminRequest->createCEPAdminReq " + t
    );
  try {
    await checkTokenValidation();
    const body = data;

    const res = await authAxios.post(`${ApiKey.createPaymentsKey}`, body);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = {};
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getPaymentsReq = async (params: { companyID: number }) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": clientsReq->getPaymentList " + t
    );
  try {
    await checkTokenValidation();
    const res = await authAxios.get(
      `${ApiKey.getPaymentsKey}/${params?.companyID}/payments`
    );
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const paymentsData = resData.payments || [];
    const _data = paymentsData?.map((item: any) => ({
      amount: item?.amount || "",
      receivedDate: item?.receivedDate || "",
      paymentID: item?.paymentID || "",
      txnDetails: item?.txnDetails || "",
      createdAt: item?.createdAt || "",
      updatedAt: item?.updatedAt || "",
      companyID: item?.companyID || "",
      userID: item?.userID || "",
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
